import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChecklist2TranslationComponent } from './fi-checklist2-translation.component';
import { MatCardModule } from '@angular/material/card';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { FiTranslationRadioGroupModule } from '@fi-shared/fi-translation-radio-group/fi-translation-radio-group.module';

@NgModule({
    declarations: [FiChecklist2TranslationComponent],
    imports: [
        CommonModule,
        MatCardModule,
        FiAppTextSharedModule,
        MatIconModule,
        MatRadioModule,
        FormsModule,
        FiTranslationRadioGroupModule,
    ],
    exports: [FiChecklist2TranslationComponent],
})
export class FiChecklist2TranslationModule {}
